<div class="mtest-medical-test-icon"
     [pTooltip]="requestedText | translate: {date: (appointmentDate | amDateFormat: 'L'), time: (appointmentDate | amDateFormat: 'LT')}"
     tooltipPosition="left">
  <ng-container *ngIf="!showOnlyIcon; else onlyIcon">
    <button siPreventDoubleClick
            class="si-button_white w-100 justify-content-center align-items-center"
            [ngClass]="{'mtest-medical-test-icon_no-pointer': case !== mtestTypeCases.CAN_SCHEDULE}"
            (click)="onClickRequestAppointment()">
      <ng-container *ngIf="case === mtestTypeCases.SCHEDULED">
        <i class="icosun-calendar mtest-medical-test-icon_request-icon mr-1"></i>
        <span [innerHTML]="requestedText | translate: {date: (appointmentDate | amDateFormat: 'L'), time: (appointmentDate | amDateFormat: 'LT')}"
        ></span>
      </ng-container>
      <ng-container *ngIf="case === mtestTypeCases.CAN_SCHEDULE">
        <span>{{'SI_APPOINTMENT_REQUEST' | translate}}</span>
        <i class="icosun-hour mtest-medical-test-icon_request-icon ml-1"></i>
      </ng-container>
      <ng-container *ngIf="case === mtestTypeCases.CANT_SCHEDULE">
        <span class="mtest-medical-test-icon_cant-schedule">{{'SI_APPOINTMENT_ONLY_AT_HEALTH_CENTER' | translate}}</span>
      </ng-container>
    </button>
  </ng-container>
  <ng-template #onlyIcon>
    <button class="si-button_icon"
            (click)="onClickRequestAppointment()"
            [disabled]="case !== mtestTypeCases.CAN_SCHEDULE">
      <i class="icosun-hour mtest-medical-test-icon_request-icon"></i>
    </button>
  </ng-template>
</div>
